import PersonalInfo from './PersonalInfo.component';

export default PersonalInfo;
